export const init = () => {
  function quillGetHTML(inputDelta) {
    const tempQuill = new Quill(document.createElement('div'))

    tempQuill.setContents(inputDelta)
    return tempQuill.root.innerHTML
  }

  const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],
    ['blockquote'],
    [{'list': 'ordered'}, {'list': 'bullet'}],
    [{'script': 'sub'}, {'script': 'super'}],
    [{'indent': '-1'}, {'indent': '+1'}],
    [{'direction': 'rtl'}],
    [{'header': [1, 2, 3, 4, 5, 6, false]}],
    [{'color': []}, {'background': []}],
    [{'font': []}],
    [{'align': []}],
    ['clean'],
  ]

  const quillEditor = document.querySelector('#editor')
  const saveDraftButton = document.querySelector('button[value=DRAFT]')
  const saveTemplateDraftButton = document.querySelector('button[value=TEMPLATEDRAFT]')
  const sendButton = document.querySelector('button[value=SEND]')
  const saveButton = document.querySelector('button[value=SAVE]')
  const signButton = document.querySelector('button[value=SIGN]')
  const form = document.querySelector('form');

  if (quillEditor) {
    const quill = new Quill('#editor', {
      modules: {
        toolbar: toolbarOptions,
      },
      theme: 'snow',
    })

    quill.on('text-change', () => {
      const contractText = document.getElementById(`${form.name}_contract`)
      const templateText = document.getElementById(`${form.name}_template`)

      if (contractText) {
        contractText.value = quillGetHTML(quill.getContents())
      }

      if (templateText) {
        templateText.value = quillGetHTML(quill.getContents())
      }
    })
  }

  function addStatusInput(documentState) {
    const input = document.createElement('input')

    input.setAttribute('type', 'hidden')
    input.setAttribute('name', `${form.name}[contract_status]`)
    input.setAttribute('value', documentState)

    return form.appendChild(input)
  }

  function addIsDraftInput(isDraftBoolean) {
    const input = document.createElement('input')

    input.setAttribute('type', 'hidden')
    input.setAttribute('name', `${form.name}[is_draft]`)
    input.setAttribute('value', isDraftBoolean)

    return form.appendChild(input)
  }

  function addSignDocumentInput() {
    const input = document.createElement('input')

    input.setAttribute('type', 'hidden')
    input.setAttribute('name', `${form.name}[sign_document]`)
    input.setAttribute('value', true)

    return form.appendChild(input)
  }

  if (saveDraftButton) {
    saveDraftButton.addEventListener('click', (e) => {
      e.preventDefault()
      addStatusInput('draft')
      if (form.reportValidity()) {
        form.submit()
      }
    })
  }

  if (saveTemplateDraftButton) {
    saveTemplateDraftButton.addEventListener('click', (e) => {
      e.preventDefault()
      addIsDraftInput(true)
      if (form.reportValidity()) {
        form.submit()
      }
    })
  }

  if (sendButton) {
    sendButton.addEventListener('click', (e) => {
      e.preventDefault()
      addStatusInput('ready')
      if (form.reportValidity()) {
        form.submit()
      }
    })
  }

  if (saveButton) {
    saveButton.addEventListener('click', (e) => {
      e.preventDefault()
      addIsDraftInput(false)
      if (form.reportValidity()) {
        form.submit()
      }
    })
  }

  if (signButton) {
    signButton.addEventListener('click', (e) => {
      e.preventDefault()
      addIsDraftInput(false)
      addStatusInput('ready')
      addSignDocumentInput()
      if (form.reportValidity()) {
        form.submit()
      }
    })
  }
}
